<template>
  <div class="registred-data-component-multiple-root">
    <div class="top-section">
      <span class="title"> {{$t('unit_grouping')}} </span>
      <v-select
        class="top-section-unit-group-select"
        v-model="view.unitGroupData.selectedUnitGroup"
        @input="setSelectedUnitGroup"
        :options="view.unitGroupData.unitGroups"
        :getOptionLabel="o => `${o.CDGRUPFILI} | ${o.NMGRUPFILI}`"
      />
    </div>
    <div class="multiple-grid-container">
      <div class="grid-panel">
        <span class="title"> {{$t('unit')}} </span>
        <div class="grid-container">
          <grid-component 
            :grid="view.unitData.gridConfig"
            :isAddingNewRow.sync="view.unitData.isAddingNewRow"
            @update:hasCheckedRows="syncUnit"
          />
        </div>
        <div class="button-container">
          <button @click="addNewUnitRow" v-show="!view.unitData.isAddingNewRow" class="button"
            > <i class="fas fa-plus"></i>  {{$t('add')}} </button>
          <button @click="removeUnit" v-show="!view.unitData.isAddingNewRow && view.unitData.hasCheckedRows" class="button"> 
            <i class="fas fa-minus-circle"></i> {{$t('to_remove')}} </button>
          <button @click="removeUnitGridNewRow" v-show="view.unitData.isAddingNewRow" class="button">
            <i class="fas fa-times"></i> {{$t('cancel')}} </button>
          <button @click="saveUnit" v-show="view.unitData.isAddingNewRow" class="button"> 
            <i class="fas fa-check"></i> {{$t('confirm')}} </button>
        </div>
      </div>
      <div class="grid-panel-flex2">
        <span class="title"> {{$t('service')}} </span>
        <div class="grid-container">
          <grid-component 
          :isAddingNewRow.sync="view.serviceData.isAddingNewRow"
          :hasCheckedRows.sync="view.serviceData.hasCheckedRows"
          :grid="view.serviceData.gridConfig"/>
        </div>
        <div class="button-container">
          <button @click="addNewServiceRow" v-show="!view.serviceData.isAddingNewRow" class="button">
            <i class="fas fa-plus"></i> {{$t('add')}} </button>
          <button @click="removeServiceRow" class="button"
            v-show="!view.serviceData.isAddingNewRow && view.serviceData.hasCheckedRows"
          > <i class="fas fa-minus-circle"></i> {{$t('to_remove')}} </button>
          <button @click="removeServiceGridNewRow" v-show="view.serviceData.isAddingNewRow" class="button"> 
            <i class="fas fa-times"></i> {{$t('cancel')}} </button>
          <button @click="saveService" v-show="view.serviceData.isAddingNewRow" class="button"> 
            <i class="fas fa-check"></i> {{$t('confirm')}} </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Controller from "../controllers/RegisteredDataMultipleController"

import GridComponent from "@/components/src/GridComponent";
import vSelect from "vue-select";

export default {
    name: "registred-data-component-multiple",
    created(){
      Controller.clearContext();
    },
    mounted(){
      this.setupUnitGroups();
    },
    components: {
      'grid-component': GridComponent,
      'v-select': vSelect
    },
    data(){
      return {
        view: {
          unitGroupData: {
            unitGroups: [],
            selectedUnitGroup: null
          },
          unitData: {
            gridConfig: Controller.UnitGridConfig,
            isAddingNewRow: false,
            hasCheckedRows: false
          },
          serviceData: {
            isAddingNewRow: false,
            hasCheckedRows: false,
            gridConfig: Controller.ServiceGridConfig
          }
        }
      }
    },
    methods: {
      syncUnit: function(hasCheckedRows) {
        if(hasCheckedRows){
          Controller.syncUnit();
        }
        this.view.unitData.hasCheckedRows = hasCheckedRows;
      },
      addNewServiceRow(){
        Controller.addNewServiceRow();
      },
      addNewUnitRow(){
        Controller.UnitGridConfig.addNewRowToGrid();
        this.view.unitData.isAddingNewRow = true;
      },
      removeServiceGridNewRow() {
        const {gridConfig: serviceGridConfig} = this.view.serviceData;
        const rows = serviceGridConfig.getRowData();
			  rows[0] && rows[0].__is_new_row && rows.shift();
        serviceGridConfig.setRowData(rows);
        this.view.serviceData.isAddingNewRow = false;
      },
      removeUnitGridNewRow() {
        const {gridConfig: UnitGridConfig} = this.view.unitData;
        const rows = UnitGridConfig.getRowData();
			  rows[0] && rows[0].__is_new_row && rows.shift();
        UnitGridConfig.setRowData(rows);
        this.view.unitData.isAddingNewRow = false;
        UnitGridConfig.enableSelection();
      },
      setupUnitGroups(){
        Controller.getUnitGroup().then(unitGroups => {
          this.view.unitGroupData.unitGroups = unitGroups;
          const selectedUnitGroup = unitGroups.find(unitGroups => unitGroups.SELECIONADA === 'S');
          this.view.unitGroupData.selectedUnitGroup = selectedUnitGroup || null;
          Controller.setContextProp('selectedUnitGroup', selectedUnitGroup);
        });
      },
      saveUnit(){
        Controller.saveUnit();
      },
      saveService(){
        Controller.updateSelectedServices();
      },
      removeServiceRow(){
        Controller.removeServiceRow();
      },
      removeUnit(){
        Controller.removeUnit();
      },
      setSelectedUnitGroup(v){
        this.view.unitGroupData.selectedUnitGroup = v || null;
        Controller.setContextProp('selectedUnitGroup', JSON.parse(JSON.stringify(v)));
      },
      getFormattedData(){
        // waiting for data format spec
      }
    }
}
</script>

<style lang="less">
  .select-350{
		.v-select ul{
			width: 350px;
			z-index: 6;
		}
	}
</style>

<style lang="less" scoped>

  .registred-data-component-multiple-root{
    padding: 10px;

    .top-section{
      .top-section-unit-group-select{
        margin-top: 5px;
        max-width: 400px;
      }      
    }

    .title{
      font-size: 1.1rem;
    }
  }

  .multiple-grid-container{
    display: flex;
    margin-top: 10px;

    .grid-panel{
      flex: 1;
      .grid-container{
        margin-top: 10px;
      }
    }

    .grid-panel-flex2{
      .grid-panel;
      flex: 4;
    }

    .button-container{
      justify-content: flex-start;

      .button{
        font-size: 0.9rem;
        padding: 6px 13px;
        margin: 5px 0px 5px 5px;
        // background-color: white;
        // color: rgb(27, 27, 27);
      }
    }
  }
</style>